import type { RouteObject } from "react-router-dom";
import { AttendanceGrid } from "./AttendanceGrid";
import { MyAttendance } from "./MyAttendance";
import { StaffList } from "./StaffList";
import { StaffNew } from "./StaffNew";
import { StaffProfile } from "./StaffProfile";

/** `/staff`, `/staff/new`, `/staff/attendance`, `/staff/:id`, and `/me/attendance` (any active staff; no sidebar entry, linked from Staff). */
export const routes: RouteObject[] = [
  { path: "staff", element: <StaffList /> },
  { path: "staff/new", element: <StaffNew /> },
  { path: "staff/attendance", element: <AttendanceGrid /> },
  { path: "staff/:id", element: <StaffProfile /> },
  { path: "me/attendance", element: <MyAttendance /> },
];
